import { Importer, ImporterField } from 'react-csv-importer';
import 'react-csv-importer/dist/index.css';

const StartlistImport = ({ processedCallback }) => {

    const handleComplete = ({ file, preview, columnFields }) => {
        const mappedColumnIdx = columnFields.reduce((acc, field, index) => {
            if (field) acc[field] = index;
            return acc;
        }, {});

        processedCallback(file, { ...mappedColumnIdx, 'header_row': !preview.skipHeaders });
    }

    return (
        <Importer
            defaultNoHeader={false}
            restartable={false}
            onComplete={handleComplete}
            

            // CSV options passed directly to PapaParse if specified:
            // delimiter={...}
            // newline={...}
            // quoteChar={...}
            // escapeChar={...}
            // comments={...}
            // skipEmptyLines={...}
            // delimitersToGuess={...}
            // chunkSize={...} // defaults to 10000
            // encoding={...} // defaults to utf-8, see FileReader API
        >
            <ImporterField name="bib_col" label="Bib number" />
            <ImporterField name="uciid_col" label="UCI ID" optional />
            <ImporterField name="first_name_col" label="First name" optional />
            <ImporterField name="last_name_col" label="Last name" optional />
            <ImporterField name="team_col" label="Team name" optional />
        </Importer>
    );
}

export default StartlistImport;